import { Component, OnInit } from '@angular/core';
import { GtmService } from '../../../shared/services/gtm/gtm.service';

@Component({
  selector: 'app-login-second-holder',
  templateUrl: './login-second-holder.component.html',
  styleUrls: ['./login-second-holder.component.scss'],
  standalone: false,
})
export class LoginSecondHolderComponent implements OnInit {
  constructor(private gtm: GtmService) {}

  ngOnInit() {
    this.gtm.sendVarGTM({ pageType: 'login_2' });
  }
}
